// @flow
import { updateIterationOrder } from './ficus_config'
import { getCurrentTimestamp } from 'er2_web_utils'
import { collaborationIsEnabled } from './collaboration'
import * as wsTypes from '../modules/websockets/server/constants/action_types'
import * as types from '../constants/action_types'
import type { LocationType } from '../reducers/analysis_panel'

export const handledClosePopup = () => ({ type: types.HANDLED_CLOSE_POPUP })

const sendClosePopupToSession = (location: LocationType, getState: Function, emit: Function) => {
    const state = getState()
    const payload = {
        applicationId: state.meta.name,
        timestamp: getCurrentTimestamp(),
        operation: {
            name: types.OT_CLOSE_POPUP,
            originator: state.token.value,
            params: { location },
        },
    }
    if (collaborationIsEnabled(state) && !state.collaborationSettings.readOnly && state.collaboration.sharedState.propagateClosePopup) {
        payload.roomId = state.collaboration.sharedState.token
        console.log(`emitting ${wsTypes.WS_CLIENT_ACTION}`)
        emit(wsTypes.WS_CLIENT_ACTION, payload)
    }
    handledClosePopup()
}

export const setAnalysisData = (location: LocationType) => (dispatch: Function, getState: Function) => {
    dispatch({ type: types.SET_ANALYSIS_DATA, location })

    // Also update the frame iteration order based on the new location.
    dispatch(updateIterationOrder(getState().analyzeFrameworkBar.iterationType))
}
export const resetAnalysisData = () => ({ type: types.RESET_ANALYSIS_DATA })
export const toggleAnalysisPanelVisible = () => ({ type: types.TOGGLE_ANALYSIS_PANEL_VISIBLE })

export const removeMapLocations = () => ({ type: types.REMOVE_MAP_LOCATIONS })
export const removeMapLocation = (location: LocationType) => (dispatch: Function, getState: Function, { emit }) => {
    sendClosePopupToSession(location, getState, emit)
    dispatch({ type: types.REMOVE_MAP_LOCATION, location })
}
